<template>
    <el-select 
        v-model="innerValue"
        value-key="value" 
        :multiple="multiple"
        :disabled="disabled"
        filterable
        clearable
        style="width: 100%"
        popper-class="popper"
        :placeholder="placeholder"
        @change="handleChangeTree"
        :filter-method="filterOption"
    >
        <el-option v-for="(item) in options" :value="item" :key="item.value" :label="item.label" />
    </el-select>
</template>
<script>
import { debounce } from '@/utils'
export default {
    name: 'ByDictSelect',
    props: {
        disabled: {
            type: Boolean,
            default: false,
        },
        clearable: {
            type: Boolean,
            default: true,
        },
        multiple: {
            type: Boolean,
            default: false,
        },
        placeholder: {
            type: String,
            default: '请选择',
        },
        value: {
            type: [Array, Object],
            default: () => [],
        },
        dictType: {
            type: String,
            default: '',
        }
    },
    data () {
        return {
            treeData: [],
            innerValue: [],
            options: [],
            params: undefined,
        }
    },
    watch: {
        dictType (val) {
            if (val) this.fetchOptions(this)
        },
        value: {
            handler(value) {
                if(this.multiple) {
                    this.innerValue = value
                } else {
                    this.innerValue = Array.isArray(value) && value[0]
                }
            },
            immediate: true,
            deep: true
        }
    },
    created () {
        const { dictType } = this
        if (dictType) {
            const getOptionsByDict = this.getApi()
            getOptionsByDict && getOptionsByDict({ dictType }).then(res => {
                if (res.code === 200) {
                    this.options = res.data.map(k => {
                        return { label: k.dictLabel, value: k.dictValue, key: k.dictValue }
                    })
                }
            })
        }
    },
    methods: {
        getApi() {
            const { option: { api } } = this.$attrs
            if (!api) return false
            const { getOptionsByDict } = api
            return getOptionsByDict
        },
        fetchOptions: debounce(_this => {
            const { dictType } = _this
            const getOptionsByDict = _this.getApi()
            getOptionsByDict && getOptionsByDict({ dictType }).then(res => {
                if (res.code === 200) {
                    _this.options = res.data.map(k => {
                        return { label: k.dictLabel, value: k.dictValue, key: k.dictValue }
                    })
                }
            })
        }, 500),
        handleChangeTree () {
            let cacheValue
            if (!this.multiple) {
                cacheValue = [this.innerValue]
            } else {
                cacheValue = this.innerValue
            }
            this.$emit('input', cacheValue)
            this.$emit('change', cacheValue)
        },
        filterOption (input, option) {
            return (
                option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
            )
        }
    }
}
</script>
<style lang="less" scoped>
.popper {
    max-height: 400px;
    overflow: auto;
}
</style>